import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  // 统一使用环境变量配置的接口地址（开发/生产由 .env 控制）
  baseURL: process.env.VUE_APP_BASE_API || 'https://dz.dhldanhao.com',
  timeout: 5000,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  }
})

// 请求拦截器（保留）
service.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
)

// 唯一的响应拦截器（合并逻辑）
service.interceptors.response.use(
  response => {
    // 后端返回的原始响应数据
    const res = response.data
    // 业务成功（code=200）直接返回数据
    if (res.code === 200) {
      return res
    }
    // 业务失败（非200）提示错误并reject
    Message.error(res.msg || '请求失败')
    return Promise.reject(res)
  },
  error => {
    console.error('请求错误：', error)
    // 网络错误/HTTP状态码错误处理
    if (!error.response) {
      Message.error('网络异常，请检查网络')
    } else if (error.response.status >= 500) {
      Message.error('服务器内部错误')
    } else if (error.response.status === 401) {
      Message.error('登录状态失效，请重新登录')
      window.location.href = '/login'
    } else {
      const errMsg = error.response.data.msg || '未知错误'
      Message.error('请求失败：' + errMsg)
    }
    return Promise.reject(error)
  }
)

export default service
